import React, { Component } from 'react';
import ReactTable from 'react-table';
import i18n from 'i18next';

class Grid extends Component {

    constructor(props) {
        super(props);

        this.breakpoints = [];
        
        this.assignResponsiveProps = this.assignResponsiveProps.bind(this);

        var newState = {
            pageText: i18n.t("Σελίδα"),
            previousText: i18n.t("Προηγούμενη"),
            nextText: i18n.t("Επόμενη"),
            ofText: i18n.t("από"),
            rowsText: i18n.t("γραμμές")
        }

        Object.assign(newState, props);
        this.state = newState;


        if (props.responsive) {
            this.breakpoints = props.responsive.sort((a, b) => a.breakPoint - b.breakpoint);
            this.assignResponsiveProps();
        }

        this.onResize = this.onResize.bind(this);
        window.onresize = this.onResize;
    }


    render()
    {
        return (<ReactTable  {...this.state}/>);
    }



    onResize() {        
        if (this.props.responsive) {
            this.assignResponsiveProps();
        }
    }

    assignResponsiveProps() {
        // find the first breakpoint who's width exceeds the current window width
        var props = this.breakpoints.find(b => b.breakpoint >= window.innerWidth);
        
        if (!props) {
            props = this.props;
        }

        if (props.breakpoint != this.currentBreakpoint) {
            this.currentBreakpoint = props.breakpoint;

            var newState = this.state;
            if (!newState)
                newState = {};

            Object.assign(newState, props);
            this.setState(newState);
        }
    }
}

export default Grid;